import React, { useEffect, useState } from 'react';
import { EeLoadingArea } from 'pages/Scenarios/components/EeLoadingArea';
import { EeTextValue } from 'pages/Scenarios/components/EeTextValue';
import { EeSelect } from 'pages/Scenarios/components/EeSelect';
import { EeNumber } from 'pages/Scenarios/components/EeNumber';
import { EeDatePicker } from 'pages/Scenarios/components/EeDatePicker';

const inputStyle = {
  backgroundColor: 'white',
  boxSizing: 'border-box',
  height: '32px',
  fontSize: '14px',
  paddingRight: '2px !important',
  width: '112px',
  borderRadius: '0',
  borderColor: '#dee0e3',
};

export const ScenarioColumn = (props: any) => {
  const { investmentScenario, isLoading, disabled, rowData } = props;

  useEffect(() => {
    setWaterfallLoading(isLoading);
  }, [isLoading]);

  const onChange = (e: any, name: string, value: any) => {
    const changedValue = value ? value : e.target.value;
    props.onChange(investmentScenario, name, changedValue);
  };

  const [waterfallLoading, setWaterfallLoading] = useState(isLoading);

  return (
    <div className="d-flex flex-column" style={{ marginRight: '70px' }}>
      <div className="d-flex">
        <div className="d-flex flex-column lens-width-250" style={{ width: '224px' }}>
          <h6 className="fs-18 text-uppercase">
            {investmentScenario.fundScenario.name}
          </h6>

          <div className="underline my-2 text-white" />
          <div className="d-flex flex-column my-1">
            <div
              className="d-flex flex-row align-items-center justify-content-between lens-width-250"
              style={{ width: '224px', margin: '2px' }}
            >
              <span
                style={{
                  fontSize: '14px',
                  color: '#1e1e1e',
                  whiteSpace: 'nowrap',
                }}
              >
                Exit Amount*
              </span>

              <EeNumber
                name={`${investmentScenario.fundScenario.id}[exitAmount]`}
                inputStyle={inputStyle}
                disabled={waterfallLoading || disabled}
                prefix={props.fundCurrencySign}
                onChange={(e: any) => onChange(e, 'exitAmount', undefined)}
                value={
                  investmentScenario
                    ? investmentScenario.exitAmount
                    : rowData.ev
                }
              />
            </div>
            <div
              className="d-flex flex-row align-items-center justify-content-between lens-width-250"
              style={{ width: '224px', margin: '2px' }}
            >
              <span
                style={{
                  fontSize: '14px',
                  color: '#1e1e1e',
                  whiteSpace: 'nowrap',
                }}
              >
                Exit Date*
              </span>
              <EeDatePicker
                name={`${investmentScenario.fundScenario.id}[exitDate]`}
                inputStyle={inputStyle}
                disabled={waterfallLoading || disabled}
                onChange={(e: any) => onChange(e, 'exitDate', e)}
                value={
                  investmentScenario
                    ? investmentScenario.exitDate
                    : investmentScenario.fundScenario.defaultExitDate
                }
              />
            </div>
          </div>

          <div className="d-flex flex-column position-relative my-1">
            <div className="or-block">
              <div className="or-frame" />
              <div className="or-text">or</div>
            </div>
            <div
              className="d-flex flex-row align-items-center justify-content-between lens-width-250"
              style={{ width: '224px', margin: '2px' }}
            >
              <span
                style={{
                  fontSize: '14px',
                  color: '#1e1e1e',
                  whiteSpace: 'nowrap',
                }}
              >
                Expected Dilution
              </span>
              <EeNumber
                suffix="%"
                inputStyle={inputStyle}
                disabled={waterfallLoading || disabled}
                name={`${investmentScenario.fundScenario.id}[expectedDilution]`}
                onChange={(e: any) => onChange(e, 'dilution', undefined)}
                captableScenario={investmentScenario?.capTableScenario}
                value={investmentScenario?.dilution}
              />
            </div>
            <div
              className="d-flex flex-row align-items-center justify-content-between lens-width-250"
              style={{ width: '224px', margin: '2px' }}
            >
              <span
                style={{
                  fontSize: '14px',
                  color: '#1e1e1e',
                  whiteSpace: 'nowrap',
                }}
              >
                Cap Table’s
              </span>
              <EeSelect
                inputStyle={inputStyle}
                disabled={waterfallLoading || disabled}
                name={`${investmentScenario.fundScenario.id}[captable]`}
                items={props.captableScenarios?.map((s: any, index: number) => {
                  if (s && s.name) {
                    return { name: s.name, id: s.id, key: index };
                  }
                })}
                value={
                  investmentScenario?.capTableScenario
                    ? investmentScenario?.capTableScenario.id
                    : ''
                }
                onChange={(e: any) =>
                  onChange(e, 'capTableScenario', undefined)
                }
              />
            </div>
          </div>

          <div className="underline my-2 text-white" />

          <div className="d-flex flex-row position-relative z-index-0 my-2">
            {waterfallLoading && <EeLoadingArea position="absolute" />}
            <div className="d-flex flex-column pr-3 w-50">
              <EeTextValue
                valueClassName="fs-14"
                title="Proceeds"
                formatProps={{
                  displayType: 'text',
                  prefix: props.fundCurrencySign,
                  thousandSeparator: true,
                  decimalScale: 0,
                }}
                value={investmentScenario?.nav}
              />
              <EeTextValue
                title="irr"
                value={investmentScenario?.irr}
                formatProps={{
                  displayType: 'text',
                  suffix: '%',
                  decimalScale: 2,
                }}
              />
            </div>
            <div className="d-flex flex-column w-50">
              <EeTextValue
                valueClassName="fs-14"
                title="multiple"
                value={investmentScenario?.multiple}
                formatProps={{
                  displayType: 'text',
                  suffix: 'x',
                  decimalScale: 2,
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
